module.exports = __webpack_public_path__ + "static/media/main-icon-small.22caa2ef.svg";